/**
 * shared/hooks/useDataRefresh.ts
 *
 * Señal de refresco cruzado, mínima y sin dependencia de React Query (los hooks
 * de ventas/dashboard/caja usan fetch manual con useEffect). Un contador por
 * dominio; las vistas lo incluyen en sus dependencias de efecto para recargar
 * automáticamente tras una operación relevante, sin recarga manual ni refetch
 * global indiscriminado.
 *
 * Uso:
 *   // en una vista de lectura:
 *   const salesVersion = useDataRefresh(s => s.salesVersion)
 *   useEffect(() => { void fetch() }, [fetch, salesVersion])
 *
 *   // tras una operación exitosa (venta/cancelación/devolución/transferencia):
 *   bumpSales()
 *
 * No usar window.location.reload(). No crear bucles: bump SOLO tras éxito.
 */
import { create } from 'zustand'

interface DataRefreshState {
  // Ventas y todo lo que deriva de ellas (dashboard, historial, caja, reportes,
  // corporativo). Cambia al crear/cancelar/devolver/confirmar/aprobar/rechazar.
  salesVersion: number
  bump: () => void
}

export const useDataRefresh = create<DataRefreshState>(set => ({
  salesVersion: 0,
  bump: () => set(s => ({ salesVersion: s.salesVersion + 1 })),
}))

/** Marca que las ventas cambiaron; las vistas suscritas recargan solas. */
export function bumpSales(): void {
  useDataRefresh.getState().bump()
}
